export const COUNTRY_FR = 'country.fr'
export const COUNTRY_UK = 'country.uk'
export const COUNTRY_DE = 'country.de'
export const COUNTRY_IT = 'country.it'
export const COUNTRY_PT = 'country.pt'
export const COUNTRY_ES = 'country.es'
export const COUNTRY_HU = 'country.hu'
export const COUNTRY_CN = 'country.cn'
export const COUNTRY_CHOOSE_LANGUAGE = 'country.choose-language'
